import React, { useState, useEffect } from "react";
import AccreditationSidebar from "../side_bar/AccreditationSidebar";
import { fetchAccreditationData } from "../utils/fetchAccreditationData";
import { deleteAccreditationFile } from "../utils/deleteAccreditationFile";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

function Accreditation({
  userId,
  selectedFolder,
  setError,
  accreditationChangeCount,
  setAccreditationChangeCount,
  // singleClassifyDone,
  // batchClassifyDone,
  // multiPageClassifyDone,
}) {
  const [accreditationData, setAccreditationData] = useState({});
  const [expandedCategories, setExpandedCategories] = useState({});
  const [fileToDelete, setFileToDelete] = useState(null);
  const [deleteCategory, setDeleteCategory] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const AccreditationAreas = [
    "Leadership and Governance",
    "External Relations",
    "Quality Assurance",
    "Research",
    "Resource Management",
    "Teaching and Learning",
    "Student Services",
    "Multi-Page Documents",
  ];

  useEffect(() => {
    async function fetchAccreditation() {
      if (!userId || !selectedFolder) {
        setAccreditationData({});
        return;
      }
      try {
        const files = await fetchAccreditationData(
          userId,
          selectedFolder.folderId
        );
        const fallbackData = {};
        AccreditationAreas.forEach((area) => {
          fallbackData[area] = [];
        });
        if (!files || files.length === 0) {
          console.log(
            "Files found for mapping accreditation is" +
              (files ? files.length : 0)
          );
          setAccreditationData(fallbackData);
        } else {
          // Group files by classificationCategory
          const grouped = {};
          files.forEach((file) => {
            const category = file.classificationCategory || "Uncategorized";
            if (!grouped[category]) {
              grouped[category] = [];
            }
            grouped[category].push(file);
          });
          // Merge grouped files into fallbackData to ensure all categories are present
          const mergedData = { ...fallbackData, ...grouped };
          setAccreditationData(mergedData);
        }
      } catch (error) {
        setError("Failed to load accreditation data: " + error.message);
      }
    }
    fetchAccreditation();
  }, [
    userId,
    selectedFolder,
    setError,
    accreditationChangeCount,
    // singleClassifyDone,
    // batchClassifyDone,
    // multiPageClassifyDone,
  ]);

  const toggleCategoryExpansion = (categoryId) => {
    setExpandedCategories((prev) => {
      const newExpanded = {};
      Object.keys(prev).forEach((key) => {
        newExpanded[key] = false;
      });
      newExpanded[categoryId] = !prev[categoryId];
      return newExpanded;
    });
  };

  const handleDeleteFile = (categoryId, fileName) => {
    // Find the file object
    const file = accreditationData[categoryId].find(
      (f) => (f.fileName || f.name) === fileName
    );
    setFileToDelete({ file, categoryId });
    setDeleteDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!fileToDelete || !userId || !selectedFolder) return;
    try {
      await deleteAccreditationFile({
        userId,
        folderId: selectedFolder.folderId,
        file: fileToDelete.file,
      });
      // Remove from local state
      setAccreditationData((prev) => ({
        ...prev,
        [fileToDelete.categoryId]: prev[fileToDelete.categoryId].filter(
          (f) =>
            (f.fileName || f.name) !==
            (fileToDelete.file.fileName || fileToDelete.file.name)
        ),
      }));

      //Increment change count to trigger sync and UI updates
      setAccreditationChangeCount((prev) => prev + 1);

      setDeleteDialogOpen(false);
      setFileToDelete(null);
    } catch (err) {
      setError("Failed to delete file: " + err.message);
      setDeleteDialogOpen(false);
      setFileToDelete(null);
    }
  };

  const handleDeleteCategory = (categoryId) => {
    console.log("Delete category", categoryId);
  };

  // Transform accreditationAreas from strings to objects with id and name
  const accreditationAreasWithIds = Object.keys(accreditationData).map(
    (area) => ({
      id: area,
      name: area,
    })
  );

  return (
    <>
      <AccreditationSidebar
        accreditationAreas={accreditationAreasWithIds}
        expandedCategories={expandedCategories}
        toggleCategoryExpansion={toggleCategoryExpansion}
        categoryFiles={accreditationData}
        deleteCategory={handleDeleteCategory}
        fileToDelete={fileToDelete}
        setDeleteDialogOpen={setDeleteDialogOpen}
        setDeleteCategory={setDeleteCategory}
        setFileToDelete={setFileToDelete}
        handleDeleteFile={handleDeleteFile} // make sure this is passed!
      />
      {/* Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Delete File</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete{" "}
            <b>{fileToDelete?.fileName || fileToDelete?.name}</b>? This action
            cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Accreditation;
